import { Schema, arrayOf } from 'normalizr'

export const listing = new Schema('listings', { idAttribute: 'ml' })
export const arrayOflistings = arrayOf(listing)
